import { Input, Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { StepsButton } from './BtnSave';
import init from './init.json';
import { useEffect } from 'react';
import { useDpiaContext } from '../dpia.context';

const { TextArea } = Input;

export default function Step8(props) {
    const { t } = useTranslation(['translation', 'dpia']);
    const { setStepNo } = useDpiaContext();

    const onNextStep = () => {
        props.nextStep();
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        setStepNo(8)
    }, []); 
    return (
        <div hidden={!props?.isActive}>
            <div className="flex">
                <div>
                    <h1 className="text-2xl font-semibold text-purple">
                        {t('step 8')}: {t('Monitoring and review')}
                    </h1>
                    <p className="text-sm text-gray-PHX m-0">
                        {t('DPIA step 8 description')}
                    </p>
                </div>
            </div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                initialValues={init.consultation}
                layout="vertical"
                name="consultation"
                form={props?.form}
            >
                <p className="text-xl font-semibold">
                    {t('Record monitoring verification and review')}
                </p>
                <h5 className="text-base font-semibold m-0">
                    {t('Monitor and verify by')}
                </h5>
                <p className="text-sm m-0"> {t('Sample data entry')}</p>
                <ul className="text-sm">
                    <li key="0">{t('DPO or department')}</li>
                    <li key="1">{t('Sample data entry description')}</li>
                </ul>
                <Form.Item name="followUpBy">
                    <TextArea
                        showCount
                        rows={4}
                        placeholder={t('Enter your details')}
                        maxLength={250}
                    />
                </Form.Item>
                <h5 className="text-base font-semibold m-0 pt-4">
                    {t('The publication of this DPIA document')}
                </h5>
                <p className="text-sm m-0"> {t('Sample data entry')}</p>
                <ul className="text-sm">
                    <li key="0">
                        {t(
                            'To be published through with restricted access to only include information'
                        )}
                    </li>
                </ul>
                <Form.Item name="publicationOfDocument">
                    <TextArea
                        showCount
                        rows={4}
                        label={false}
                        placeholder={t('Enter your details')}
                        maxLength={250}
                    />
                </Form.Item>
            </Form>
            <Divider />
            <StepsButton previous={onPreviousStep} next={onNextStep} />
        </div>
    );
}
